import { FileRejection } from "@mantine/dropzone";

import { showErrorToast } from "#app/notifications";
import { fileTypeValidator, getFileValidationError } from "#shared/helpers/dropZoneValidator";

export const DROPZONE_MAX_SIZE = 500 * 1024 ** 2;

export const useDropzoneHandlers = (
  accept: Record<string, string[]>,
  validExtensions: string[],
) => {
  const inputAccept = Object.values(accept).flat().join(",");
  const validMimeTypes = Object.keys(accept);

  const validator = (file: File) => fileTypeValidator(file, validExtensions, validMimeTypes);

  const handleReject = (rejectedFiles: FileRejection[]) => {
    if (rejectedFiles.length > 0) {
      const fileValidationError = getFileValidationError(rejectedFiles);
      showErrorToast({ title: fileValidationError.message });
    }
  };

  return { inputAccept, validator, handleReject };
};
